import React from 'react'
import { ScrollView } from 'react-native-gesture-handler';
import { SHr, SLoad, SNavigation, SPage, SText, STheme, SView } from 'servisofts-component2'
import Container from '../../Components/Container';
import Verified_icon from '../../Assets/verified_icon.svg';
import MDL from '../../MDL';

export default class ChecklistChoferes extends React.Component {
constructor(props) {
super(props);
this.state = {
loading: true,
error: null,
choferes: [],
};
}

async componentDidMount() {
await this.loadChoferes();
}

loadChoferes = async () => {
this.setState({ loading: true, error: null });
try {
const choferes = await MDL.checklist.getChecklistChoferes();
const rows = (Array.isArray(choferes) ? choferes : [])
.map((item) => ({
id: item?.lChofer_id,
nombre: String(item?.sNombreChofer ?? ''),
dni: String(item?.sDNI ?? ''),
telefono: String(item?.sTelefono ?? ''),
matriculaRemolque: String(item?.sMatriculaRemolque ?? ''),
matriculaTractora: String(item?.sMatriculaTractora ?? ''),
}))
.sort((a, b) => a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' }));
this.setState({
choferes: rows,
loading: false,
error: null,
});
} catch (error) {
this.setState({
loading: false,
error: error?.message || String(error),
choferes: [],
});
}
}

renderItem(item, index) {
const hasTelefono = !!String(item?.telefono || '').trim();
return (
<SView
key={String(item?.id ?? index)}
col={"xs-12"}
onPress={() => {
SNavigation.navigate('/check/vehiculos', { sdni: item.dni || '' });
}}
style={{
borderRadius: 10,
borderWidth: 1,
borderColor: STheme.color.lightGray,
padding: 12,
backgroundColor: STheme.color.primary,
}}
>
<SText font='AlbertSans' bold fontSize={13} color={STheme.color.text}>lChofer_id: {String(item?.id ?? '-')}</SText>
<SHr height={3} />
<SText font='AlbertSans' fontSize={12} color={STheme.color.text}>sNombreChofer: {item.nombre || '(vacio)'}</SText>
<SHr height={2} />
<SText font='AlbertSans' fontSize={12} color={STheme.color.text}>sDNI: {item.dni || '(vacio)'}</SText>
<SHr height={2} />
<SText font='AlbertSans' fontSize={12} color={hasTelefono ? STheme.color.success : STheme.color.danger}>
sTelefono: {item.telefono || '(vacio)'}
</SText>
<SHr height={2} />
<SText font='AlbertSans' fontSize={12} color={STheme.color.text}>sMatriculaTractora: {item.matriculaTractora || '(vacio)'}</SText>
<SHr height={2} />
<SText font='AlbertSans' fontSize={12} color={STheme.color.text}>sMatriculaRemolque: {item.matriculaRemolque || '(vacio)'}</SText>
</SView>
);
}

render() {
const { loading, error, choferes } = this.state;
return (
<SPage center disableScroll>
<Container flex>
<SView col={"xs-12"} flex style={{ backgroundColor: STheme.color.card, padding: 24, borderRadius: 16 }}>
<SView col={"xs-12"} center>
<SView col={"xs-12"} center style={{ alignItems: 'center' }} row>
<Verified_icon width={18} height={18} fill={STheme.color.secondary} style={{ marginRight: 8 }} />
<SText font='AlbertSans' center fontSize={24} color={STheme.color.secondary}>CHOFERES ACTIVOS</SText>
</SView>
<SHr height={10} />
<SView col={"xs-12"} height={1} style={{ backgroundColor: STheme.color.lightGray }} />
<SHr height={10} />
<SText font='AlbertSans' center fontSize={14} color={STheme.color.text}>Lista obtenida desde checklist_choferes</SText>
<SHr height={10} />
</SView>
<SView col={"xs-12"} flex style={{ minHeight: 0 }}>
<ScrollView
style={{ flex: 1, width: '100%' }}
contentContainerStyle={{ paddingBottom: 12 }}
keyboardShouldPersistTaps="handled"
showsVerticalScrollIndicator
>
{loading ? (
<SView col={"xs-12"} center style={{ alignItems: 'center', justifyContent: 'center' }}>
<SLoad />
<SHr height={10} />
<SText center color={STheme.color.text}>Cargando choferes...</SText>
</SView>
) : null}
{error ? (
<SView col={"xs-12"}>
<SText center color={STheme.color.danger}>{error}</SText>
</SView>
) : null}
{!loading && !error && choferes.length <= 0 ? (
<SView col={"xs-12"}>
<SText center>No hay choferes activos.</SText>
</SView>
) : null}
{!loading && !error ? choferes.map((item, index) => (
<SView key={String(item?.id ?? index)} col={"xs-12"}>
{this.renderItem(item, index)}
<SHr height={8} />
</SView>
)) : null}
</ScrollView>
</SView>
</SView>
</Container>
<SHr height={20} />
</SPage>
);
}
}